// src/components/Login.js
import React from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { auth, db } from "../config/firebaseConfig";
import { MainContext } from "../App";

const Login = () => {
  const [email, setEmail] = React.useState("");
  const { setSuccess, setError, setMessage } = React.useContext(MainContext);

  const handleAddToWaitlist = async () => {
    try {
      const snapshot = await db
        .collection("waitlist")
        .where("email", "==", email)
        .get();
      if (!snapshot.empty) {
        setError(true);
        setMessage("You are already on the waitlist!");
      } else {
        await db.collection("waitlist").add({
          email: email,
        });
        setEmail("");
        setSuccess(true);
        setMessage("You have been added to the waitlist!");
      }
    } catch (error) {
      setError(true);
      setMessage("There was an error adding you to the waitlist.");
    }
  };

  return (
    <Box sx={{ width: "300px", textAlign: "center" }}>
      <Typography
        variant="h5"
        sx={{ marginBottom: "1rem", fontWeight: "bold" }}
      >
        Join The Waitlist
      </Typography>
      <TextField
        fullWidth
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      {/* <TextField
        fullWidth
        label="Password"
        variant="outlined"
        type="password"
        sx={{ marginBottom: "1rem" }}
      /> */}
      {/* <Button variant="contained" fullWidth>
        Login
      </Button> */}
      <Button variant="contained" fullWidth onClick={handleAddToWaitlist}>
        Submit
      </Button>
    </Box>
  );
};

export default Login;
